import { render, staticRenderFns } from "./groupsendfayan.vue?vue&type=template&id=6e289804&scoped=true"
import script from "./groupsendfayan.vue?vue&type=script&lang=js"
export * from "./groupsendfayan.vue?vue&type=script&lang=js"
import style0 from "./groupsendfayan.vue?vue&type=style&index=0&id=6e289804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e289804",
  null
  
)

export default component.exports